const _console = window.consoleReference || window.console;
const isNewRelicAvailable = () => !!window.newrelic;
const isDev = () => window.location.host !== 'sports.williamhill.com';
export const register = () => {
    return { appName: 'sb-gaming-widget' };
};
export const logEvent = ({ contextName = 'sbGamingWidget', objectName, actionName, metadata }) => {
    const eventName = `${contextName}:${objectName}_${actionName}`;
    if (isDev() || !isNewRelicAvailable()) {
        _console.info(eventName, metadata);
    }
    if (isNewRelicAvailable()) {
        const attributes = Object.assign(Object.assign({}, register()), metadata);
        window.newrelic.addPageAction(eventName, attributes);
    }
};
export const logError = ({ error, metadata }) => {
    if (isDev() || !isNewRelicAvailable()) {
        _console.error(error, metadata);
    }
    if (isNewRelicAvailable()) {
        const attributes = Object.assign(Object.assign({}, register()), metadata);
        window.newrelic.noticeError(error, attributes);
    }
};
